import { useParams } from 'react-router-dom';
import SEOMeta from '../../components/SEOMeta';
import { PLANS } from '../../../shared/criar-musica-catalog.mjs';
import { TransactionShell } from './OrderPage';
import { useCreateMusicOrder } from './useOrder';
import './styles.css';
import './transaction.css';

export default function CriarMusicaSuccessPage() {
  const { slug = '' } = useParams();
  const { order } = useCreateMusicOrder(slug, 5000);
  const hasVideo = order?.form.planId === 'song_video';
  const plan = order ? PLANS[order.form.planId] : null;
  return (
    <>
      <SEOMeta title="Pedido confirmado | Inspira Músicas" description="Sua música personalizada entrou em produção." path={`/criar-musica/sucesso/${slug}`} noIndex />
      <TransactionShell>
        <section className="cmt-state">
          <div className="cmt-success-mark">✓</div>
          <span className="cm-kicker" style={{ marginTop: 24 }}>Pedido confirmado</span>
          <h1>A canção completa de {order?.form.recipientName || 'quem você ama'} foi liberada</h1>
          <p>O pagamento foi confirmado. Você receberá os arquivos no e-mail{order?.form.whatsapp ? ' e no WhatsApp informado' : ''}. <strong>{plan?.deliveryLabel || 'A entrega já está sendo preparada'}</strong>.</p>
          {order?.delivery?.audioUrl && <a className="cm-primary" href={`/ouvir/${slug}`}>Ouvir a canção completa</a>}
          {!!order?.delivery?.videoUrls?.[0] && <a className="cm-back" href={order.delivery.videoUrls[0]} target="_blank" rel="noreferrer">Baixar vídeo com as fotos</a>}
          {hasVideo && <p style={{ maxWidth: 490, fontSize: 12 }}>As fotos já estão salvas e o vídeo personalizado entrou na preparação.</p>}
          <a className="cm-back" href="/">Voltar para a Inspira</a>
        </section>
      </TransactionShell>
    </>
  );
}
